import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query';
import { useGetMatterByIdQuery, useGetMatterRestrictedInfoQuery } from 'store/api/matters';
import { MatterDto } from 'types/matters';

interface UseMatterWithRestrictedReturn {
    data: MatterDto | undefined;
    refetch: () => void;
    isLoading: boolean;
    error: FetchBaseQueryError | SerializedError | undefined;
}

export const useMatterWithRestricted = (matterId?: string): UseMatterWithRestrictedReturn => {
    const {
        data: matterData,
        refetch: refetchMatter,
        isLoading: isMatterLoading,
        error: matterError,
    } = useGetMatterByIdQuery(matterId ?? skipToken, { refetchOnMountOrArgChange: true });

    const shouldGetRestricted = matterError && 'status' in matterError && matterError.status === 403;

    const {
        data: restrictedData,
        isLoading: isRestrictedLoading,
        error: restrictedError,
    } = useGetMatterRestrictedInfoQuery(matterId ?? skipToken, {
        skip: !shouldGetRestricted,
    });

    return {
        data: shouldGetRestricted ? restrictedData : matterData,
        refetch: () => {
            void refetchMatter();
        },
        isLoading: isMatterLoading || (shouldGetRestricted ? isRestrictedLoading : false),
        error: shouldGetRestricted ? restrictedError : matterError,
    };
};
